import './lib/vendor/pep'

import Vue from 'vue'

import * as vClickOutside from "v-click-outside";
Vue.use(vClickOutside);

import './lib/client'

// Apps.vue is used for frontend
// import Apps from './Apps.vue'

// extranet.vue is used for BTO extranet
import Apps from './Apps.vue'
import router from './router'
import './registerServiceWorker'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(Apps)
}).$mount('#app')
